import * as Icons from '@heroicons/react/24/outline';
import React from 'react';

interface NotificationIconProps {
    iconName?: string;
    description?: string;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({ iconName, description }) => {
    const IconComponent = iconName ? Icons[iconName] : null;

    return (
        <>
            {IconComponent && <IconComponent />}
            {description && <span dangerouslySetInnerHTML={{ __html: description }} />}
        </>
    );
};

export default NotificationIcon;
